// Relay is a pattern introduced by facebook
// https://facebook.github.io/react/blog/2015/02/20/introducing-relay-and-graphql.html
// https://facebook.github.io/react/blog/2015/03/19/building-the-facebook-news-feed-with-relay.html
// https://gist.github.com/staltz/868e7e9bc2a7b8c1f754
const layers = require('./odo-layers')
const cache = require('./odoql-exe/cache')
const { createRoot } = require('react-dom/client')

module.exports = (el, rootComponent, exe, options) => {
  const renderRoot = createRoot(el)

  // needs async checking
  let _memory = {}
  const _state = layers()
  let log = () => {}
  if (options != null && options.hub != null)
    log = message => options.hub.emit('[odo-relay] {message}', { message: message })
  const update = () => {
    log('updating')
    renderRoot.render(rootComponent(_state.get(), _memory, options != null ? options.hub : void 0))
    log('updated')
  }
  const _cache = cache(exe, options)
  _cache.on('ready', update)
  _cache.on('result', _state.apply)
  const Relay = {
    mount: () => {
      renderRoot.render(rootComponent(_state.get(), _memory, options != null ? options.hub : void 0, options))
    },
    update: params => {
      Object.assign(_memory, params)
      _cache.run(rootComponent.query(_memory))
    },
    layer: _state.layer,
    params: () => _memory,
    clearParams: () => { _memory = {} },
    hub: () => options != null ? options.hub : null,
    state: () => _state.get(),
    refreshQueries: queries => {
      const queriesDictionary = {}
      for (let query of queries)
        queriesDictionary[query] = null
      _cache.apply(queriesDictionary)
    }
  }
  return Relay
}

